import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";
import thunk from "redux-thunk";
import products from "./Slices/Products/productsSlices";
import categories from "./Slices/Categories/categoriesSlices";
import subCategories from "./Slices/Categories/subCategoriesSlices";
import loginReducer from "./Slices/Login/loginSlices";



const persistConfig = {
    key: "root",
    storage,
    whitelist: ["products", "categories", "subCategories"],
};

const rootReducer = combineReducers({
    products,
    categories,
    subCategories,
   login: loginReducer,
    
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default configureStore({
  reducer: persistedReducer,
  middleware: [thunk],
});
